<template>
    <div>
        <BreadCrumb :data="breadCrumb" />  
        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" :limit="limit" :setLimit="setLimit" :page="page"
         :setPage="setPage" :pageData="pageInfo"  :inputs="inputs" :search="search" />    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';

     let breadCrumb = [
        { label: i18n.t('pages.user.userLogs'), url: "/User/Logs" },
    ]

       let fields = [ 
         { key: 'CreatedAt',  type: "date", label: i18n.t('user.list.actionDate'),  keys: ['CreatedAt'] },
         { key: 'TableName', label: i18n.t('user.list.tableName'), keys:['TableName'] },
         { key: 'Operation', label: i18n.t('user.list.action'), keys:['Operation']},
         { key: 'Username', label: i18n.t('user.list.username'), keys:['Username']},
         { key: 'Function', label: i18n.t('user.list.action'), keys:['Function'] },
    ]; 

     let inputs = [ 
        { key: 'begin-date', label: i18n.t('user.list.beginDate'), type: "Date", checked: false, val:""},
        { key: 'end-date', label: i18n.t('user.list.endDate'), type: "Date", checked: false, val:""},
        { key: 'function', label: i18n.t('user.list.action'), type: "String", checked: false, val:""},
        { key: 'table-name', label: i18n.t('user.list.tableName'), type: "String", checked: false, val:""},
        { key: 'username', label: i18n.t('user.list.username'), type: "String", checked: false, val:""},
    ]; 

   

    let filtered = ['CreatedAt', "TableName", 'Operation', 'Username', 'Function']; 

    export default {
        name: 'Logs',
        created: async function(){
            await this.$store.dispatch('getLogs', this.params)
        },
        computed:{
            fetchData(){
                this.$store.dispatch('getLogs', this.params)
            },
            loading(){
                return this.$store.getters.getUserLoading
            },
            list(){
                return this.$store.getters.getLogs
            },
            pageInfo(){
                return this.$store.getters.getLogsPageInfo
            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, limit:10, page: 1, offset: 0, modalOpen: false,
                modalProps: {}, currentForm:"Logs", modalName: "", dismissCountDown: 0, inputs,
                params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('getLogs', this.params)

            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('getLogs', this.params)

            }
        },
        components:{
            BreadCrumb, Table
        },
        methods:{
            search(){
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key]
                })
                this.$store.dispatch('getLogs', this.params)
            },
            setLimit:function(limit){
                this.limit = limit
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                }
            },
          
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/Logs.vue